import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

import SPremiumLogin from "../components/Authentication/SPremiumLogin";

const SPremiumPrivateRoute = ({ actions, state }) => {
  const { loggedSPremiumUser } = state;
  const token = localStorage.getItem("spremiumAuthToken");

  useEffect(() => {
    actions.setLoggedSPremiumUser();
  }, []);

  return token && loggedSPremiumUser ? <Outlet /> : <SPremiumLogin />;
};

export default SPremiumPrivateRoute;
